export const sendEvent = (eventName: string, eventParams: Record<string, any>) => {
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, eventParams);
    }
};
